"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InProductMessageUIService = exports.MESSAGE_UI_TYPE = void 0;
const superstruct_1 = require("superstruct");
const Common_1 = require("./Common");
const CssThemeUtil_1 = require("./CssThemeUtil");
const CommonTypes_1 = require("./types/CommonTypes");
exports.MESSAGE_UI_TYPE = {
    MODAL: "modal",
    NON_MODAL: "nonModal",
};
function buildModalElement() {
    var _a, _b, _c;
    const template = document.createElement("template");
    template.innerHTML = Common_1.consentDialogHTML;
    const modal = template.content.cloneNode(true).firstElementChild;
    modal.id = "adp-ipm-dialog";
    (_a = modal.querySelector(".adp-dialog__content")) === null || _a === void 0 ? void 0 : _a.classList.add("adp-dialog__content--ipm");
    (_b = modal.querySelector(".adp-dialog__actionbar")) === null || _b === void 0 ? void 0 : _b.remove();
    (_c = modal.querySelector(".adp-dialog__close")) === null || _c === void 0 ? void 0 : _c.addEventListener("click", () => {
        modal.close();
    });
    return (0, CssThemeUtil_1.setTheme)(modal);
}
class InProductMessageUIService {
    constructor() {
        if (!InProductMessageUIService.modal) {
            const modal = buildModalElement();
            InProductMessageUIService.modal = modal;
        }
        InProductMessageUIService.modal.addEventListener("close", (ev) => {
            var _a;
            (_a = this.onMessageClose) === null || _a === void 0 ? void 0 : _a.call(this, ev.target.querySelector("iframe"));
        });
        window.addEventListener("message", (event) => {
            if (!(0, superstruct_1.is)(event.data, CommonTypes_1.IpmContentMessageStruct)) {
                return;
            }
            // Expect message from iframe. Context should be different, therefore the window object should be different.
            if (event.source === window) {
                return;
            }
            InProductMessageUIService.modal.close();
        });
    }
    buildContentFrame(url, hooks) {
        const frame = document.createElement("iframe");
        frame.onload = () => {
            hooks.onloaded(frame);
        };
        frame.src = url;
        return frame;
    }
    renderMessage(options) {
        var _a;
        const { modal } = InProductMessageUIService;
        if (!modal.parentElement) {
            document.body.appendChild(modal);
        }
        if (modal.open) {
            throw new Error("A message is already in progress.");
        }
        if (!((_a = options.url) === null || _a === void 0 ? void 0 : _a.trim())) {
            throw new Error("URL is required.");
        }
        (0, CssThemeUtil_1.setTheme)(modal, options.style);
        if (options.type === "nonModal") {
            modal.classList.add("adp-dialog--nonmodal");
        }
        else {
            modal.classList.remove("adp-dialog--nonmodal");
        }
        this.setModalTitle(options.title);
        this.repositionModal(options);
        this.resizeModal(options);
        const messageContent = this.buildContentFrame(options.url, {
            onloaded: (element) => {
                var _a;
                if (options.type === "nonModal") {
                    modal.show();
                }
                else {
                    modal.showModal();
                }
                (_a = this.onMessageOpen) === null || _a === void 0 ? void 0 : _a.call(this, element);
            },
        });
        const contentContainer = modal.querySelector(".adp-dialog__content");
        if (!contentContainer) {
            throw new Error("Content container cannot be found.");
        }
        contentContainer.replaceChildren(messageContent);
    }
    repositionModal({ posX, posY, webPosX, webPosY }) {
        const { modal } = InProductMessageUIService;
        const x = webPosX || `${posX}px`;
        const y = webPosY || `${posY}px`;
        modal.style.marginLeft = x;
        modal.style.marginTop = y;
    }
    resizeModal(options) {
        const { modal } = InProductMessageUIService;
        const container = modal.querySelector(".adp-dialog__container");
        if (!container) {
            throw new Error("No container found");
        }
        const height = options.webHeight || (options.height && `${options.height}px`);
        const width = options.webWidth || (options.width && `${options.width}px`);
        if (height) {
            container.style.height = height;
        }
        if (width) {
            container.style.width = width;
        }
    }
    setModalTitle(str) {
        const title = InProductMessageUIService.modal.querySelector(".adp-dialog__title");
        if (!title) {
            throw new Error("Title bar is unexpectedly missing.");
        }
        title.textContent = str || "";
    }
}
exports.InProductMessageUIService = InProductMessageUIService;
